import { render, staticRenderFns } from "./GantiRegistrasi.vue?vue&type=template&id=1e9b9008&scoped=true"
import script from "./GantiRegistrasi.vue?vue&type=script&lang=js"
export * from "./GantiRegistrasi.vue?vue&type=script&lang=js"
import style0 from "./GantiRegistrasi.vue?vue&type=style&index=0&id=1e9b9008&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b9008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e9b9008')) {
      api.createRecord('1e9b9008', component.options)
    } else {
      api.reload('1e9b9008', component.options)
    }
    module.hot.accept("./GantiRegistrasi.vue?vue&type=template&id=1e9b9008&scoped=true", function () {
      api.rerender('1e9b9008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/ganti_registrasi_pasien/GantiRegistrasi.vue"
export default component.exports